import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import axios from "axios";
import { imageUrl, websiteUrl } from "../../const/constants";
import { getBookById, getOurBooks } from "./_request";

const BookDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [aboutIntro, setAboutIntro] = useState(null);
  const [aboutLoading, setAboutLoading] = useState(true);
  const [books, setBooks] = useState([]);
  const [book, setBook] = useState(null);
  const BOOK_URL = `${imageUrl}/matbuaatImages`;
  const BOOK_PDF_URL = `${imageUrl}/matbuaatPdf`;
  // Related books carousel (RTL like Mujallah)
  const [currentPage, setCurrentPage] = useState(0);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);
  const itemsPerPage = 4;

  const getBooksList = async () => {
    setAboutLoading(true);
    try {
      const response = await getOurBooks();
      if (response.Result) {
        setBooks(response.Books);
        setAboutLoading(false);
      }
    } catch (error) {
      // Handle error if needed
    } finally {
      setAboutLoading(false);
    }
  };

  const getBookByIds = async (id) => {
    setAboutLoading(true);
    try {
      const response = await getBookById(id);
      if (response.Result) {
        setBook(response.Book);
        setAboutLoading(false);
      }
    } catch (error) {
      // Handle error if needed
    } finally {
      setAboutLoading(false);
    }
  };
  const handleBookClick = (bookId) => {
    navigate(`/tableeghat/mutabaat/${bookId}`);
  };
  useEffect(() => {
    setAboutLoading(true);
    axios
      .get(`${websiteUrl}/api/about?section_key=ourbooks_intro&active=1`)
      .then((res) => {
        if (res.data.success && res.data.data && res.data.data.length > 0) {
          setAboutIntro(res.data.data[0]);
        } else {
          setAboutIntro(null);
        }
        setAboutLoading(false);
      })
      .catch(() => {
        setAboutIntro(null);
        setAboutLoading(false);
      });

    getBooksList();
    getBookByIds(id);
  }, [id]);
  // Load items for related books carousel
  const loadRelatedPageItems = useCallback(
    (sourceBooks, pageIndex, totalPages) => {
      const filtered = sourceBooks.filter((b) => b.id !== book?.id);
      const sortedDesc = [...filtered].sort((a, b) => {
        const ay = parseInt(a.publishYear, 10) || 0;
        const by = parseInt(b.publishYear, 10) || 0;
        return by - ay;
      });
      const startIndex = pageIndex * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const pageItems = sortedDesc.slice(startIndex, endIndex);
      setDisplayedItems(pageItems);
      setHasMore(pageIndex < totalPages - 1);
      setHasPrev(pageIndex > 0);
    },
    [book],
  );

  useEffect(() => {
    // Initialize related books carousel once books and book are loaded
    if (!books || books.length === 0) return;
    const filtered = books.filter((b) => b.id !== book?.id);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    setCurrentPage(0); // rightmost first page in RTL
    loadRelatedPageItems(books, 0, totalPages);
  }, [books, book, loadRelatedPageItems]);

  const handleRelatedNext = () => {
    if (!hasMore) return;
    const filtered = books.filter((b) => b.id !== book?.id);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    loadRelatedPageItems(books, nextPage, totalPages);
  };

  const handleRelatedPrev = () => {
    if (!hasPrev) return;
    const filtered = books.filter((b) => b.id !== book?.id);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const prevPage = currentPage - 1;
    setCurrentPage(prevPage);
    loadRelatedPageItems(books, prevPage, totalPages);
  };
  return (
    <>
      <Header />
      <div
        dir="rtl"
        className="bg-white min-h-screen w-full px-5 sm:px-10 md:px-10 lg:px-20 text-black text-center font-nastaleeqRegular font-normal"
      >
        <div className="pt-10 sm:pt-16 md:pt-20">
          <div className="bg-primaryBG rounded-3xl py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-10 lg:px-20 transition-all duration-300 hover:shadow-lg">
            {aboutLoading || !book ? (
              <div className="flex justify-center items-center h-24">
                <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
              </div>
            ) : (
              <div className="flex flex-col sm:flex-col lg:flex-row justify-center lg:justify-around items-center lg:items-start gap-4 md:gap-8">
                <div className="flex flex-col lg:flex-row items-center lg:items-start w-full">
                  <img
                    src={`${BOOK_URL}/${book.image}`}
                    alt={book.bookName}
                    className="w-full lg:w-1/2 rounded-lg transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
                    loading="lazy"
                  />
                  {/* <img
                                        src={`${BOOK_URL}/${book.image}`}
                                        alt={book.bookName}
                                        className="w-full lg:w-1/2 rounded-lg transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
                                        loading="lazy"
                                    /> */}
                </div>
                <div className="flex flex-col gap-8 w-full">
                  <p className="font-nastaleeqKasheeda mt-5 text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-5 transition-colors duration-300 hover:text-primary">
                    {book.bookName}
                  </p>
                  <div className="flex gap-8">
                    <div className="flex flex-col gap-2 items-start">
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/80">
                        مصنف کا نام:
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/80">
                        اشاعت کا سال:
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/80">
                        کاپیوں کی تعداد:
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/80">
                        کتاب کا ورژن:
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl transition-colors duration-300 hover:text-primary/80">
                        پبلشر کا نام:
                      </p>
                    </div>
                    <div className="flex flex-col gap-2 items-start">
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl hover:text-primary transition-all duration-300">
                        {book.writerName}
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl hover:text-primary transition-all duration-300">
                        {book.publishYear}
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl hover:text-primary transition-all duration-300">
                        {book.totalBooks}
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl hover:text-primary transition-all duration-300">
                        {book.bookVersion}
                      </p>
                      <p className="font-nastaleeqKasheeda text-lg sm:text-xl md:text-xl lg:text-2xl hover:text-primary transition-all duration-300">
                        {book.publisherName}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Dynamic About Intro */}
          {aboutLoading ? (
            <div className="flex justify-center items-center h-24">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
            </div>
          ) : aboutIntro ? (
            <div className="mt-[48px] flex flex-col items-center justify-center gap-6 transition-all duration-300">
              <p className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl transition-colors duration-300 hover:text-primary">
                {aboutIntro.section_title}
              </p>
              <p className="font-nastaleeqRegular text-lg sm:text-xl md:text-xl lg:text-2xl px-5 lg:px-[242px] transition-colors duration-300 hover:text-primary/90">
                {aboutIntro.section_content}
              </p>
              {aboutIntro.image && (
                <img
                  src={`${websiteUrl}/aboutImage/${aboutIntro.image}`}
                  alt="about"
                  className="mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto mt-4"
                />
              )}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              کوئی تعارف دستیاب نہیں
            </div>
          )}

          {/* PDF Section */}
          {aboutLoading || !book ? (
            <div className="flex justify-center items-center h-24 mt-12">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
            </div>
          ) : book.pdf ? (
            <div className="bg-primaryBG rounded-3xl py-8 px-5 sm:px-10 md:px-10 lg:px-20 mt-12 transition-all duration-300 hover:shadow-lg">
              <p className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-6 transition-colors duration-300 hover:text-primary">
                کتاب کا پی ڈی ایف
              </p>
              <iframe
                src={`${BOOK_PDF_URL}/${book.pdf}`}
                className="w-full h-[600px] sm:h-[800px] lg:h-[1000px] rounded-lg border-2 border-primary/20"
                title="Book PDF"
              ></iframe>
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8 mt-12">
              پی ڈی ایف دستیاب نہیں
            </div>
          )}

          {/* Related Books Section (RTL Carousel like Mujallah) */}
          <div className="bg-primaryBG flex flex-col items-center gap-y-8 py-10 px-10 lg:px-[121px] rounded-3xl mt-12 mb-12">
            <p className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl">
              ہماری کتابیں
            </p>
            {displayedItems.length > 0 ? (
              <div className="relative w-full overflow-hidden">
                {/* Left button - moves to older items (next page) */}
                {hasMore && (
                  <button
                    onClick={handleRelatedNext}
                    className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-gray-700 shadow-xl rounded-full p-3 transition-all duration-300 hover:bg-white hover:text-primary hover:scale-110 hover:shadow-2xl border border-gray-200"
                    aria-label="Go to older items"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </button>
                )}

                {/* Right button - moves to newer items (previous page) */}
                {hasPrev && (
                  <button
                    onClick={handleRelatedPrev}
                    className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm text-gray-700 shadow-xl rounded-full p-3 transition-all duration-300 hover:bg-white hover:text-primary hover:scale-110 hover:shadow-2xl border border-gray-200"
                    aria-label="Go to newer items"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                )}

                <div className="flex w-full transition-all duration-300">
                  <div className="flex flex-row-reverse flex-nowrap gap-6 min-w-full justify-center">
                    {displayedItems.map((rb) => (
                      <div
                        key={rb.id}
                        className="flex flex-col gap-4 items-center cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg rounded-lg p-2"
                        onClick={() => handleBookClick(rb.id)}
                      >
                        <img
                          src={`${BOOK_URL}/${rb.image}`}
                          alt={rb.bookName}
                          className="h-[200px] w-[129px] rounded-md transition-all duration-300 hover:shadow-xl hover:scale-[1.02]"
                          loading="lazy"
                        />
                        <p className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda transition-all duration-300 hover:text-primary">
                          {rb.bookName}
                        </p>
                        <p className="text-md sm:text-lg md:text-lg lg:text-xl text-[#4C4C4C] transition-all duration-300 hover:text-primary/80">
                          {rb.writerName}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Dot indicators - RTL order */}
                <div className="flex gap-2 mt-4 flex-row-reverse justify-center">
                  {(() => {
                    const filtered = books.filter((b) => b.id !== book?.id);
                    const totalPages = Math.ceil(
                      filtered.length / itemsPerPage,
                    );
                    return Array.from({ length: totalPages }, (_, i) => (
                      <div
                        key={i}
                        onClick={() => {
                          setCurrentPage(i);
                          loadRelatedPageItems(books, i, totalPages);
                        }}
                        className={`w-3 h-3 rounded-full cursor-pointer transition-all duration-300 hover:scale-125 ${
                          i === currentPage
                            ? "bg-primary shadow-lg shadow-primary/50"
                            : "bg-gray-400 hover:bg-gray-500"
                        }`}
                        aria-label={`Go to page ${i + 1}`}
                      />
                    ));
                  })()}
                </div>
              </div>
            ) : (
              <div className="text-center text-gray-500 py-8">
                کوئی کتابیں دستیاب نہیں
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookDetail;
